import request from "@/axios";

/** 获取分页的接口 */
export const getActiveCodeGenerateList = params => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyConfig/page",
    method: "get",
    params
  });
};

/** 新增激活码生成接口 */
export const addActiveCodeGenerate = data => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyConfig/save",
    method: "post",
    data
  });
};

/** 编辑激活码生成的接口 */
export const editActiveCodeGenerate = data => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyConfig/update",
    method: "post",
    data
  });
};

/** 分页激活码明细 */
export const getActiveCodeDetailList = params => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyConfig/pageDetail",
    method: "get",
    params
  });
};

/** 删除激活码生成配置 */
export const deleteActiveCodeGenerate = id => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyConfig/delById",
    method: "get",
    params: {
      id
    }
  });
};

/** 导出激活码 */
export const exportActiveCode = params => {
  return request({
    url: "/lebo-member/web/member/doudian/cdkeyConfig/exportExcel",
    method: "get",
    params,
    responseType: "blob"
  });
};

/** 查看操作日志 */
export const getOperationLog = params => {
  return request({
    url: "/lebo-member/web/member/operation-log/page",
    method: "get",
    params: {
      ...params,
      module: '6'
    }
  });
};

//^ ^--------------初始化数据-------------^ ^
/** 获取业务字典中的 cdk业务类型 */
export const getBusinessType = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "member_cdkey_business_type"
    }
  });
};
